const AppConfig = {
  key: {
    LoggedIn: 'loggedInPredictLotto'
  }
}

export default AppConfig;
